<template>
  <div class="modal-box">
    <div class="modal cancel-modal" @click.self="$emit('close-btn-click')">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">申込みをキャンセルします</h4>
          </div>
          <div class="modal-body">
            <div class="cancel-summary">
              <p>アカウント名：{{ audience.name }} 様</p>
              <p>支払方法　　：{{ audience.payment_method }}</p>
              <p>支払額　　　：{{ audience.amount }}</p>
            </div>
            <template v-if="canRefund">
              <div class="cancel-description">
                <p>この申込みをキャンセルします。</p>
                <p>キャンセル後、このチケットは使用できなくなります。</p>
                <p>販売期間中の場合は、キャンセルした枚数分が再度販売可能になります。</p>
              </div>
              <div class="cancel-method">
                <p>下記よりキャンセル方法を選択してください。</p>
                <div class="cancel-method-option">
                  <input id="cancel_method_refund" type="radio" name="cancel_method" value="refund" v-model="cancelMethod" />
                  <label for="cancel_method_refund">チケットを無効にして、払い戻す</label>
                  <p class="small">※クレジットカードへ払い戻しを行います。</p>
                </div>
                <div class="cancel-method-option">
                  <input id="cancel_method_invalidate" type="radio" name="cancel_method" value="invalidate" v-model="cancelMethod" />
                  <label for="cancel_method_invalidate">チケットのみ無効にする</label>
                  <p class="small">※払い戻しは行われません。</p>
                </div>
              </div>
            </template>
            <div v-else class="cancel-description">
              <p>{{ refundUnavailableText }}</p>
              <p>返金が必要な場合は、銀行振込など別の方法で購入者へ返金してください。</p>
              <p>チケットを無効にする場合は次へ進んでください。</p>
              <p>販売期間中の場合は、キャンセルした枚数分が再度販売可能になります。</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" @click="$emit('close-btn-click')">閉じる</button>
            <button type="button" class="btn btn-primary" @click="selectMethod">次へ</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    audience: { type: Object, required: true },
    // 主イベントに送金レコードがあると払い戻しは実行できない
    is_can_not_refund_event: { type: Boolean, required: true },
  },
  data() {
    return {
      cancelMethod: 'refund',
    };
  },
  computed: {
    isCvs() {
      return this.audience.payment_method === 'コンビニ払い';
    },
    canRefund() {
      return !this.isCvs && !this.is_can_not_refund_event;
    },
    // 支払方法をこのモーダルの冒頭に出しているため、コンビニ払いの案内を先に出す
    refundUnavailableText() {
      if (this.isCvs) {
        return 'この申込みはコンビニ支払いで購入されているため、TIGETから払い戻しを行うことはできません。';
      }
      return 'この申込みは売上金の送金が完了しているため、TIGETから払い戻しを行うことはできません。';
    },
  },
  methods: {
    selectMethod() {
      this.$emit('select-method', this.canRefund ? this.cancelMethod : 'invalidate');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $translucent-black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;

  .cancel-modal {
    display: flex;
    overflow-y: auto;

    .modal-title {
      font-size: 18px;
    }

    .modal-dialog {
      max-width: 100%;
      width: 700px;
      margin: auto;

      @media screen and (max-width: $break-point) {
        margin: auto 30px;
      }
    }

    .modal-body {
      padding: 15px;
      line-height: 1.5em;
      margin-bottom: 15px;

      p {
        margin-bottom: 10px;
      }

      .cancel-description,
      .cancel-method {
        margin-top: 20px;
      }

      .cancel-method-option + .cancel-method-option {
        margin-top: 20px;
      }
    }

    .modal-content {
      box-shadow: none;
      z-index: 9997;
    }

    .modal-footer {
      display: flex;
      justify-content: center;
      gap: 10px;
    }
  }
}
</style>
